import { render, staticRenderFns } from "./newsManagement.vue?vue&type=template&id=97cd85a8&scoped=true&"
import script from "./newsManagement.vue?vue&type=script&lang=js&"
export * from "./newsManagement.vue?vue&type=script&lang=js&"
import style0 from "./newsManagement.vue?vue&type=style&index=0&id=97cd85a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cd85a8",
  null
  
)

export default component.exports